
    .facelift3513331464__root .CounterBadge3740516708__root {
        --CounterBadge3740516708-color-standard: #3899ec;
        --CounterBadge3740516708-color-danger: #ee5951;
    }

/* st-namespace-reference="../../../../src/skins/facelift/CounterBadge.st.css" */